import { apolloClientService } from "../../../../services/apollo-client";
export const highestUsage = {
    getDropdownData,
    usageDays
};

function getDropdownData(groupCode,primaryLanguageCode) {
    let APIquery =
      `{  getDropdownData(input:{groupCode:"` +
      groupCode +
      `",languageCode:"`+primaryLanguageCode+`"})
     }`;
    return apolloClientService.ApolloClientgqls(APIquery);
} 

export default async function usageDays(startDate,endDate,accountId, saId, accountIdChanged){
   let APIquery=
   `{
    getUsageTrends(
      input: {displayMode: "D2BD", startDate: "` +
      startDate +
      `", endDate: "` +
      endDate +
      `", additionalIdentifiers: [{
        name: "mode",
        value: "HIGHEST_USAGE_DAYS"
        }]}
    ) {
        usageQuantity {
          intervalName
          intervalShortName
          intervalDateTime
          quantity
          isHighestUsageDay
          noData,
          __typename
        }
        usageUnit
        isDailyUsageAvailable
        totalUsage
        messageContentDetails{
            contentCode,
            commonWeekdayName,
            topUsageDayIntervalName,
            topUsageDayIntervalDate,
            topUsageDayQuantity
        }
      __typename
    }
  }`
let headers={
    accountId: accountId,
    saId: saId
  }
  return accountIdChanged ? apolloClientService.ApolloClientgqlsUsage(APIquery,headers, "network-only") : apolloClientService.ApolloClientgqlsUsage(APIquery,headers);
}
